/* ==========================================================================
   ImageRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ImageRxjs',
    init: true,
    start: true,
    css: {
        load: 'lazyload',
        loading: 'lazyloading',
        loaded: 'lazyloaded',
        hidden: 'is-hidden',
        vertical: 'is-vertical'
    },
    lazySrc: '/comun/images/shim.gif',
    resize: {
        width: 100,
        height: 100,
        operation: 'resize',
        suboperation: 'crop',
        quality: 85
    }
};

module.exports = () => config;
